export default "__VITE_ASSET__b4450494__"